/**
 * 채팅 첨부로 받을 수 있는 확장자 — 서버 `FilenameDomainService` 의 `uploads` 버킷 허용 목록과 같다.
 *
 * 파일 선택창 목록(`accept`)이 서버보다 좁아(이미지·pdf·doc·xls 만) «.txt 는 목록 밖인데 받아진다»
 * 로 보였다(GS A3-27). 둘을 같은 목록으로 맞춘다. 실제 검증은 서버가 한다 — 이 목록은 고르기 편의다.
 */
export const CHAT_ATTACHMENT_EXTENSIONS = [
  // 문서
  "pdf",
  "doc",
  "docx",
  "hwp",
  "hwpx",
  "hwt",
  "txt",
  "csv",
  // 표
  "xls",
  "xlsx",
  "cell",
  // 발표
  "ppt",
  "pptx",
  "show",
  // 압축
  "zip",
  "rar",
  "7z",
  // 이미지
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
  "tiff",
  "tif",
] as const;

/** `<input type="file" accept>` 값. */
export const CHAT_ATTACHMENT_ACCEPT = CHAT_ATTACHMENT_EXTENSIONS.map(
  (ext) => `.${ext}`,
).join(",");
